import { Button } from "@/components/Button"
import { ChevronLeft } from "@material-ui/icons"
import { ButtonProps } from "react-aria-components"

export const SideBarBackButton = (props: ButtonProps & {title: string}) =>
    <Button {...props} className="h-full text-white" variant="link">
        <ChevronLeft/>
        {props.title}
    </Button>